module.exports = __webpack_public_path__ + "img/薪资待遇@2x.3dd4134e.png";